export default function ({className}) {
    return(
        <div className={`h-5 w-5  border-2  border-t-transparent rounded-full animate-spin ml-2 ${className}`}>
        </div>
    )
}